// PENDING LEGAL/COMPLIANCE REVIEW. Every word a patient reads about the
// optional SSN lives here, so legal's final wording is a change to this
// file only. Keep it true to what the backend actually does (see
// MedSyncIQBackend app/modules/patient/ssn_service.py): one-way hash only,
// never shown back, used only for record matching.

export const SSN_COPY = {
  title: "Social Security Number",
  why: "Adding your SSN helps us accurately match your records across different hospitals and health systems.",
  notRequired: "You don't need it to create an account or use MedSyncIQ, and you can skip this step.",
  consentLabel: "I agree to let MedSyncIQ use my SSN only to match my health records, as described in the",
  privacyLinkLabel: "Privacy Policy",
  submit: "Add SSN",
  skip: "Skip for now",
  reenterHint: "For your security, enter the full number again to change it.",
  providedOn: (date: string) => `Provided on ${date}. We keep only a one-way code, never the number itself.`,
  notProvided: "Not provided. Adding it helps us match your records across hospitals.",

  // Consent & Privacy page card
  consentCardDescription:
    "Lets MedSyncIQ use a one-way code made from your SSN to match your records across hospitals and health systems. We never store or show your full SSN.",
  withdraw: "Remove my SSN",
  withdrawConfirmTitle: "Remove your SSN?",
  withdrawConfirmBody:
    "We'll delete the code made from your SSN, and it will no longer be used to match your records. Matching will rely on your name, date of birth, and contact details instead. You can add it again at any time.",
  withdrawConfirm: "Yes, remove it",
  withdrawn: "Your SSN has been removed.",
} as const;

/** Privacy Policy section. Same facts as above, in policy form. */
export const SSN_PRIVACY_POLICY_SECTION = {
  title: "Social Security Number (Optional)",
  body:
    "You may choose to give us your Social Security Number (SSN). It is never required to create an account or use MedSyncIQ. " +
    "We use it for one purpose only: to accurately match your health records across different hospitals and health systems. " +
    "We never store your full SSN. When you submit it, we immediately convert it into a secure, one-way code using a secret key, then discard the number. " +
    "That code cannot be turned back into your SSN, and no one at MedSyncIQ, including our staff and support team, can see your number. " +
    "We never show your SSN back to you or to anyone else, never include it in exports or shared records, and never sell it or use it for marketing. " +
    "We keep a record of when you added, changed, or removed it, and when it was used for matching, but that record never contains the number or the code. " +
    "To protect against misuse, the number of times an SSN can be submitted is limited. " +
    "You can remove it at any time from the Consent & Privacy page; we then delete the code and stop using it for matching.",
} as const;
